import * as React from 'react';
import { Alert } from '@nackle/paper';

const InvalidRoute = () => (
    <Alert
        type="warning"
        className="invalid-route"
        message="Invalid Route - page does not exist. Please check the url and try again."
    />
);

export default InvalidRoute;
